import { render, staticRenderFns } from "./mBankList.vue?vue&type=template&id=3b853e0f&"
import script from "./mBankList.vue?vue&type=script&lang=js&"
export * from "./mBankList.vue?vue&type=script&lang=js&"
import style0 from "./mBankList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports